import axiosInstance from "../../../config/axios";

export const getProfile = async () => {
    return axiosInstance.get('/sales/profile');
};

// Authoritative per-user module permissions for the logged-in sales rep.
// Drives the sidebar's dynamic tabs (redux `auth.module`); fetched right after
// sales login instead of relying on the login payload's `rolesPermission`.
export const getMyPermissions = async () => {
    return axiosInstance.get('/sales/myPermissions');
};

export const changePassword = async (data: any) => {
    return axiosInstance.post('/sales/changePassword', data);
};

export const getCustomerList = async () => {
    return axiosInstance.get('/sales/customerList');
};

export const setSalesSession = async (customerId: string, tradeShow?: number | string | null) => {
    const url = tradeShow !== undefined && tradeShow !== null && tradeShow !== ''
        ? `/sales/setSalesSession/${customerId}?tradeShow=${tradeShow}`
        : `/sales/setSalesSession/${customerId}`;
    return axiosInstance.post(url);
};

export const getBannerList = async (customerId: string) => {
    return axiosInstance.get('/sales/bannerList', { headers: { "customer" : customerId } });
};